import React, { useState, useEffect } from 'react'
import { Card, Col, Container } from 'reactstrap'
// actions
import { getRegions, addNewRegion, updateRegion, deleteRegion, updateRegionStatus } from "../../../store/catalogs/Regions/actions"
import { useSelector, useDispatch } from "react-redux";
import { RegionsRegisterModal } from './RegionsRegisterModal';

import Table1 from "../../../components/Common/TableContainer"
import { SearchBar } from '../../../components/Common/SearchBar'
import { BackButton } from '../../../components/Common/BackButton'
import { NewRegisterButton } from '../../../components/Common/NewRegisterButton'
import Breadcrumb from '../../../components/Common/Breadcrumb'
import { TableItemDeleteModal } from '../../../components/Common/TableItemDeleteModal'
import { ToastContainer } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css"


export const CatalogLayoutRegions = (props) => {

    // * Redux
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getRegions("?limit=20&page=0"));
    }, [])

    const { regions, loading, total, currentPage } = useSelector(state => ({
        regions: state.regions.regions,
        loading: state.regions.loading,
        region: state.regions.region,
        total: state.regions.total,
        currentPage: state.regions.currentPage
    }));
    // * Redux end

    // Modal HOOKS
    const [isUpdate, setIsUpdate] = useState(false);
    const [rowInfo, setRowInfo] = useState();
    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [searchData, setSearchData] = useState('');

    useEffect(() => {
        dispatch(getRegions(`?limit=20&page=0&search=${searchData}`))
    }, [searchData])

    const onUpdate = (values) => {
        setIsUpdate(true)
        setRowInfo(values)
        setShowModal1(true)
    }

    const onDelete = (values) => {
        setRowInfo(values)
        setShowModal2(true)
    }

    const RegisterModalRespInfo = (values, active) => {
        if (isUpdate) {
            const updValue = { ...values, id: rowInfo.id };
            dispatch(updateRegion(updValue));
            dispatch(updateRegionStatus({ id: rowInfo.id, recordStatus: active }));
        } else {
            dispatch(addNewRegion(values));
        }
        setTimeout(() => {
            dispatch(getRegions("?limit=20&page=0"));
        }, 500);
        setIsUpdate(false);
        setRowInfo('');
    };    

    const columns = React.useMemo(
        () => [
            {
                Header: 'Estado',
                width: '12%',
                Cell: ({ row }) => (
                    <div>
                        <div className='text-left'>{row.original.state ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Ciudad/Municipio',
                width: '12%',
                Cell: ({ row }) => (
                    <div>
                        <div className='text-left'>{row.original.municipality ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Estatus',
                width: '5%',
                Cell: ({ row }) => (
                    row.original.recordStatus == true ?
                        <div className='text-success'>Activo</div> :
                        <div className='text-danger'>Inactivo</div>
                ),
            },
            {
                width: '5%',
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div className="page-title-box d-flex align-items-center justify-content-center">
                        <button className="btn btn-outline-secondary text-primary mx-1 rounded-3 p-0 me-2" onClick={() => { onUpdate(row.original) }}>
                            <span className="mdi mdi-18px mdi-lead-pencil p-2"></span>
                        </button>
                        <button className="btn btn-outline-secondary text-danger mx-1 rounded-3 p-0" onClick={() => { onDelete(row.original) }}>
                            <span className="mdi mdi-18px mdi-delete p-2"></span>
                        </button>
                    </div>
                ),
            },
        ],
        []
    )

    const modalClose = () => {
        setIsUpdate(false)
    }

    const onDeleteConfirmation = () => {
        dispatch(deleteRegion(rowInfo))
        setRowInfo('')
    }

    const getPagination = (params) => {
        dispatch(getRegions(`${params}&search=${searchData}`))
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="" >
                    <Col className="col-12" style={{ padding: 40 }}>
                        <Card className='' style={{ padding: 20 }}>

                            <Breadcrumb breadcrumbItem1='catalogsmenu' breadcrumbItem2='RegionsCatalog' />

                            <Card className='' style={{ padding: 20 }}>

                                <div className='pe-1'>
                                    <BackButton props={props} />
                                </div>

                                <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9col-xxl-9 mb-2 ps-3 pe-3">
                                        <SearchBar setSearchData={setSearchData} />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3 pe-3">
                                        <NewRegisterButton setShowModal={setShowModal1} showModal={showModal1} />
                                    </div>
                                </div>

                                <div className='ms-1'>
                                    <Table1 currentPage={currentPage} getPagination={getPagination} total={total} loading={loading} isAddTableBorderStrap columns={columns} data={regions} />
                                </div>

                                <RegionsRegisterModal
                                    setShowModal={setShowModal1}
                                    showModal={showModal1}
                                    modalRespInfo={RegisterModalRespInfo}
                                    isUpdate={isUpdate}
                                    rowInfo={rowInfo}
                                    modalClose={modalClose}
                                />

                                <TableItemDeleteModal onDeleteConfirmation={onDeleteConfirmation} props={props} setShowModal={setShowModal2} showModal={showModal2} modalHeader='Eliminar Regiones' modalBodyLabel='¿Está seguro que desea eliminar la región seleccionada?' />
                            </Card>

                            <br />
                            <br />

                        </Card>
                    </Col>
                    <ToastContainer autoClose={2000} newestOnTop={true} />
                </Container>
            </div>
        </React.Fragment>
    )
}
